import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-ink text-paper pt-24 md:pt-32 pb-10 mt-24">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="mb-6"><Logo size="lg" onDark /></div>
                        <p className="font-body text-sm leading-relaxed font-light text-paper/70 max-w-sm">
                            Ihr Schuh- und Schlüsseldienst in Regensburg.
                            Meisterhandwerk seit 2002.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <h3 className="font-display text-2xl font-bold text-paper mb-6 pb-3 border-b border-paper/20 inline-block">Navigation</h3>
                        <ul className="space-y-3 font-body text-sm">
                            <li><Link to="/" className="hover:text-brand transition-colors">Start</Link></li>
                            <li><Link to="/leistungen" className="hover:text-brand transition-colors">Leistungen</Link></li>
                            <li><Link to="/kontakt" className="hover:text-brand transition-colors">Kontakt</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h3 className="font-display text-2xl font-bold text-paper mb-6 pb-3 border-b border-paper/20 inline-block">Besuchen Sie uns</h3>
                        <ul className="space-y-4 font-body text-sm font-light">
                            <li className="flex gap-3">
                                <MapPin size={16} className="mt-1 shrink-0 text-brand" />
                                <span>Weichser Weg 5<br/>93059 Regensburg<br/>Donau-Einkaufszentrum (DEZ)</span>
                            </li>
                            <li className="flex gap-3">
                                <Phone size={16} className="mt-1 shrink-0 text-brand" />
                                <a href="tel:+499414610027" className="hover:text-brand transition-colors">+49 941 4610027</a>
                            </li>
                            <li className="flex gap-3">
                                <Mail size={16} className="mt-1 shrink-0 text-brand" />
                                <a href="mailto:agisschluesseldienst@gmail.com" className="hover:text-brand transition-colors">agisschluesseldienst@gmail.com</a>
                            </li>
                            <li className="flex gap-3">
                                <Clock size={16} className="mt-1 shrink-0 text-brand" />
                                <span>Mo – Sa: 10:00 – 20:00</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-paper/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs font-body text-paper/50">
                    <p>© {new Date().getFullYear()} Mein Schuster. Alle Rechte vorbehalten.</p>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                        <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-brand transition-colors">Impressum</Link>
                        <span className="text-paper/20">·</span>
                        <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-brand transition-colors">Datenschutz</Link>
                        <span className="text-paper/20">·</span>
                        <Link to="/agb" data-testid="footer-agb-link" className="hover:text-brand transition-colors">AGB</Link>
                    </div>
                    <p className="tracking-[0.2em] uppercase">Schuh- &amp; Schlüsseldienst · Regensburg · Seit 2002</p>
                </div>
            </div>
        </footer>
    );
}
